<template>
    <v-footer class="align-center bottom-0  w-100 ">
        <div class="dfont footer w-100 text-center align-center">
            <v-icon icon="mdi-copyright"/> {{ new Date().getFullYear() }} Arata
        </div>
    </v-footer>
</template>

<style lang="css" scoped>

</style>